/**
 *
 * LOGIN
 *
 */

import { mapGetters, mapActions } from 'vuex';

import { /* cookieGetItem, */ cookieSetItem } from '@/global/cookie';

import { LoginCommonMixin } from '@/scripts/Login/Login.mixin';

import { LOADING_MESSAGE } from './LoginPhone.constants';

export const LoginPhoneMixin = {
  name: 'LoginPhoneMixin',

  mixins: [LoginCommonMixin],

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    }
  },

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
      loading: 'loading',
      immLoading: 'immLoading',
    }),

    ...mapGetters('LoginPhone', {
      loginPhoneStatus: 'loginPhoneStatus',
      loginPhoneMessage: 'loginPhoneMessage',
    }),
  },

  methods: {
    ...mapActions({
      ma_logout: 'logout',
    }),

    ...mapActions('LoginPhone', {
      ma_postLoginBindMobile: 'postLoginBindMobile',
    }),

    async _postLoginBindMobile({ isFromForm }) {
      if (!this.mobileCode) {
        this.isInvalid = true;
        return;
      }
      if (isFromForm && !this.shortMobile) {
        this.isInvalid = true;
        return;
      }
      await this.ma_postLoginBindMobile({
        studentId: this.mg_userInfo.studentId,
        smsCode: this.mobileCode,
        mobile: isFromForm ? this.c_mobile : undefined,
        shortMobile: isFromForm ? this.shortMobile : undefined,
        //bindWechat: 'true' === cookieGetItem('isLoginFromWechat'),
        vendorId: this.vendorId,
      });
      if (this.loginPhoneStatus === 200) {
        this._afterLoginPhone();
      } else {
        this.isInvalid = true;
      }
    },

    postLoginBindMobileFromUserInfo() {
      this._postLoginBindMobile({
        isFromForm: false,
      })
    },

    postLoginBindMobileFromForm() {
      this._postLoginBindMobile({
        isFromForm: true,
      })
    },

    backToLogin() { },

    afterLoginPhone() { },

    async _afterLoginPhone() {
      await this.getUserInfo();
      cookieSetItem('isLoginFromWechat', 'false')
      this.afterLoginPhone();
    },

    _loginPhoneCreated() { },
  },
};
